import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CalendarComponent} from './calendar.component';
import {CalendarDialogRepeatComponent} from './dialog-repeat/dialog-repeat.component';
import {CalendarFormComponent} from './form/calendar-form.component';
import {ModalModule} from 'ngx-bootstrap/modal';
import {BsDatepickerModule} from 'ngx-bootstrap/datepicker';
import {TimepickerModule} from 'ngx-bootstrap/timepicker';
import {TypeaheadModule} from 'ngx-bootstrap/typeahead';
import {HttpClientModule} from '@angular/common/http';
import {CommonModule} from '@angular/common';
import {
  CoreModule,
  ResourceLoaderService,
  SuggestionService
} from 'inet-core';
import {CalendarTodayComponent} from "./calendar-today/calendar-today.component";
import {CalendarWidgetComponent} from "./calendar-widget/calendar-widget.component";
import {CalendarDialogViewComponent} from "./dialog-view/dialog-view.component";
import {CalendarAttendeeListComponent} from "./attendee-list/attendee-list.component";
import {CalendarDialogDelete} from "./dialog-delete/dialog-delete.component";
import {AttachmentListComponent} from "./attachment-list/attachment-list.component";
import {CalendarService} from "./calendar.service";
import {CalendarViewerComponent} from "./calendar-viewer/calendar-viewer.component";
import {CalendarRoutingModule} from "./calendar-routing.module";
import {TimePickerModalModule, FileModule} from "inet-ui";
import {FullCalendarModule} from '@fullcalendar/angular';

import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import interactionPlugin from '@fullcalendar/interaction';
import bootstrapPlugin from '@fullcalendar/bootstrap';
import {BsDropdownModule} from "ngx-bootstrap/dropdown";
import {NgSelectModule} from "@ng-select/ng-select";
import {BadgeTrackerPipe} from "./utils/common/badge-tracker.pipe";
import {BadgeStatusPipe} from "./utils/common/badge-status.pipe";
import {TruncatePipe} from "./utils/common/truncate.pipe";

FullCalendarModule.registerPlugins([
  dayGridPlugin,
  timeGridPlugin,
  listPlugin,
  interactionPlugin,
  bootstrapPlugin
]);

@NgModule({
  imports: [
    BsDatepickerModule.forRoot(),
    TimepickerModule.forRoot(),
    ModalModule.forRoot(),
    TypeaheadModule.forRoot(),
    ReactiveFormsModule,
    CommonModule,
    FormsModule,
    CoreModule,
    CommonModule,
    TimePickerModalModule,
    FileModule,
    HttpClientModule,
    CalendarRoutingModule,
    FullCalendarModule,
    BsDropdownModule,
    NgSelectModule,

  ],
  exports: [
    CalendarComponent,
    CalendarDialogRepeatComponent,
    CalendarFormComponent,
    CalendarTodayComponent,
    CalendarWidgetComponent,
    CalendarDialogViewComponent,
    CalendarAttendeeListComponent,
    CalendarDialogDelete,
    AttachmentListComponent,
    CalendarViewerComponent,
    FullCalendarModule
  ],
  declarations: [
    CalendarComponent,
    CalendarDialogRepeatComponent,
    CalendarFormComponent,
    CalendarTodayComponent,
    CalendarWidgetComponent,
    CalendarDialogViewComponent,
    CalendarAttendeeListComponent,
    CalendarDialogDelete,
    AttachmentListComponent,
    CalendarViewerComponent,
    BadgeTrackerPipe,
    BadgeStatusPipe,
    TruncatePipe
  ],
  providers: [
    CalendarService,
    ResourceLoaderService,
    SuggestionService
  ],
  entryComponents: [
    CalendarDialogViewComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CalendarModule {

}
